export const PackagingType = Object.freeze({
	envelope: 'Envelope',
	letter: 'Envelope',
	bills: 'Bill',
	envelope_non_standard: 'Large Envelope/Flat',
	large_envelope: 'Large Envelope/Flat',
	envelope_flat_rate: 'Flat Rate Envelope',
	postcard: 'Postcard',
	package: 'Package/Thick Envelope',
	package_large: 'Large Package',
	package_oversized: 'Oversized Package',
	netstamps: 'Envelope',
	thick_envelope: 'Package/Thick Envelope',
	package_normal: 'Package/Thick Envelope',
	flat_rate_box: 'Medium Flat Rate Box',
	priority_mail_large_flat_rate_bo: 'Large Flat Rate Box',
	priority_mail_small_flat_rate_bo: 'Small Flat Rate Box',
	flat_rate_padded_envelope: 'Padded Flat Rate Envelope',
	priority_mail_regional_rate_boxa: 'Regional Rate Box A',
	priority_mail_regional_rate_boxb: 'Regional Rate Box B',
	legal_envelope_flat_rate: 'Legal Flat Rate Envelope',
	critical_mail: 'Envelope',
	priority_mail_regional_rate_boxc: 'Regional Rate Box C',
});
